export const STEP_PROGRESS_DOT_SIZE = 12
export const STEP_PROGRESS_PILL_WIDTH = 12
export const STEP_PROGRESS_PILL_HEIGHT = 36
export const STEP_PROGRESS_GAP = 16

export const stepProgressDotsHeight = (total: number) =>
  2 * (total - 1) * (STEP_PROGRESS_DOT_SIZE + STEP_PROGRESS_GAP) +
  STEP_PROGRESS_PILL_HEIGHT
